import { render, staticRenderFns } from "./editCandidateSickDays.vue?vue&type=template&id=d6d7379c&"
import script from "./editCandidateSickDays.vue?vue&type=script&lang=js&"
export * from "./editCandidateSickDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports